/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle theme`)
};

const es_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tema`)
};

const de_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design umschalten`)
};

const nl_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thema wisselen`)
};

const fr_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changer de thème`)
};

const it_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia tema`)
};

const pt_br2_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar tema`)
};

const pt_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar tema`)
};

const ja_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テーマを切り替える`)
};

const zh_nav_toggle_theme = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换主题`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_toggle_theme = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_toggle_theme(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nav_toggle_theme", locale)
	if (locale === "en") return en_nav_toggle_theme(inputs)
	if (locale === "es") return es_nav_toggle_theme(inputs)
	if (locale === "de") return de_nav_toggle_theme(inputs)
	if (locale === "nl") return nl_nav_toggle_theme(inputs)
	if (locale === "fr") return fr_nav_toggle_theme(inputs)
	if (locale === "it") return it_nav_toggle_theme(inputs)
	if (locale === "pt-BR") return pt_br2_nav_toggle_theme(inputs)
	if (locale === "pt") return pt_nav_toggle_theme(inputs)
	if (locale === "ja") return ja_nav_toggle_theme(inputs)
	return zh_nav_toggle_theme(inputs)
};